"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../../..");
var interpreter_utils_1 = require("../../../interpreter-utils");
var layout_reader_1 = require("./layout-reader");
var title_reader_1 = require("./title-reader");
var lodash_1 = require("lodash");
var ControlModelReader = /** @class */ (function (_super) {
    __extends(ControlModelReader, _super);
    function ControlModelReader(properties, controlResolver, context) {
        return _super.call(this, 'control', properties, controlResolver, context, new title_reader_1.TitleReader(properties, context)) || this;
    }
    ControlModelReader.convertFields = function (fields, context) {
        var result = {};
        lodash_1.forIn(fields, function (value, key) {
            if (!lodash_1.isNil(value)) {
                lodash_1.set(result, key, context.fieldProvider(value));
            }
        });
        return result;
    };
    ControlModelReader.prototype.readValue = function (value) {
        var id = interpreter_utils_1.getOptionalProperty(value, 'id', interpreter_utils_1.uniqueId());
        var selector = interpreter_utils_1.getRequiredProperty(value, 'selector');
        var controlProperties = this.properties.getControlProperties(id);
        var fields = interpreter_utils_1.getOptionalProperty(value, 'fields', {
            field: interpreter_utils_1.getOptionalProperty(value, 'fieldSystemName'),
        });
        controlProperties.generatedId = ControlModelReader.PREFIX_FOR_CONTROL_ID + "-" + lodash_1.values(fields).join('-') + controlProperties.idSuffix;
        return new __1.ControlModel(id, ControlModelReader.convertFields(fields, this.context), selector, interpreter_utils_1.getOptionalProperty(value, 'bindings', {}), interpreter_utils_1.getOptionalProperty(value, 'actions', {}), controlProperties, this.controlResolver(selector), interpreter_utils_1.getOptionalProperty(value, 'isConfigurable', false));
    };
    ControlModelReader.PREFIX_FOR_CONTROL_ID = 'selenium-test';
    return ControlModelReader;
}(layout_reader_1.LayoutReader));
exports.ControlModelReader = ControlModelReader;
//# sourceMappingURL=control-model-reader.js.map